import { IDoctorBaseDto } from '@/shared/interfaces';
import { Card, HorizontalContainer, VerticalContainer } from '@/components';
import { CaregiverAvatar } from '@/features/booking/shared/ui/CaregiverAvatar';
import { CaregiverRoleEnum } from '@/shared/enums';
import { R } from '@/shared/EnumResources.resx';
import { cn } from '@/lib/cn';

type CaregiverCardProps = {
    caregiver: IDoctorBaseDto;
    isCoveredByOverlay?: boolean;
};

const getCaregiverTitle = (role: CaregiverRoleEnum) => {
    switch (role) {
        case CaregiverRoleEnum.Midwife:
            return R.CaregiverRoleEnum_Midwife_Indefinite;
        case CaregiverRoleEnum.Dietitian:
            return R.CaregiverRoleEnum_Dietitian_Indefinite;
        case CaregiverRoleEnum.Nurse:
            return R.CaregiverRoleEnum_Nurse_Indefinite;
        default:
            return '';
    }
};

export default function CaregiverCard({
    caregiver,
    isCoveredByOverlay = false,
}: CaregiverCardProps) {
    return (
        <Card
            className={cn(
                'border-border-default! h-76',
                isCoveredByOverlay && 'border-transparent!',
            )}
        >
            <VerticalContainer spacing="md">
                <HorizontalContainer spacing="sm" className="items-center">
                    <CaregiverAvatar photoUrl={caregiver.PhotoUrl} />
                    <VerticalContainer
                        spacing="none"
                        className="justify-center"
                    >
                        <div className="text-text-heading line-clamp-1 font-bold">
                            {caregiver.FullName}
                        </div>
                        <span className="text-sm">
                            {getCaregiverTitle(caregiver.CaregiverRole)}
                        </span>
                    </VerticalContainer>
                </HorizontalContainer>

                <div className="line-clamp-7 overflow-hidden text-ellipsis">
                    {caregiver.Description}
                </div>
            </VerticalContainer>
        </Card>
    );
}
